import { types as t, getParent } from 'mobx-state-tree';
import NewVariantItem from './NewVariantItem';

export default t.model("NewVariantGroup", {
    GroupKey: t.maybeNull(t.string),
    Items: t.optional(t.array(NewVariantItem), []),
    
}).views(self => ({


})).actions(self => ({

}));